import { useNavigate } from 'react-router'
import { Button } from '../common/html/button'
import { COMPONENTS } from '../routers/constants'
import classes from './ErrorCommon.module.scss'

export const GoToDashboard = () => {
  const navigate = useNavigate()

  const action = () => {
    navigate(COMPONENTS.dashboard.components.dashboard.route)
  }

  return (
    <Button
      isI18n
      className={classes.goToDashboardBtn}
      label={'error.GO_TO_DASHBOARD'}
      style={{ backgroundColor: '#FFFFFF', border: '1px solid #D5D5D5' }}
      action={action}
    />
  )
}
